// import axios from "axios"
import axios, { AxiosRequestConfig, AxiosResponse } from "axios"
import * as tools from '../assets/tools'
import router from '../router'
import * as gtools from '../../../../../global/js/tools'


// interface of login
interface ILogin {
  phone: string,
  phone_country_code: number,
  phone_country_key: string,
  login_type?: number,
  captcha?: string,
  password: string
}
// interface of Payment
interface IPay {
  sku_id: string | null,
  amount: number | null,
  currency: string | null,
  pay_way: number | null,
  pay_fee: number | null,
  order_type: number | null,
  user_id: number | null,
  country: string | null,
  channel: string | null
}

// request
axios.interceptors.request.use((config: AxiosRequestConfig) => {
  config.baseURL = gtools.getHost('API');
  // config.baseURL = process.env.NODE_ENV === 'development' ? '/' : gtools.getHost()
  config.headers = {
    "Authorization": tools.getTokenBySession(),
    "X-App-Channel": 1
  }
  return config
})

// response
axios.interceptors.response.use(
  (response: AxiosResponse) => {
  // console.warn(response)
  return response.data
},
// onerror process
(error: any) => {
  window.$dialog.destroyAll()
  window.$dialog.error({
    title: 'Error Message',
    content: error.message,
    onClose: () => {
      router.push('/login')
    }
  })
  return {
    code: -1,
    msg: error.message
  }
})

// thirdparty signup
export const thridLogin = (type: string, token: string) => {
  const param = {
    third_platform: type,
    third_token: token
  }
  return axios.post('/v1/user/oauth_login', param)
}


// get user id
export const getUid = (uid: number | string | null) => {
  return axios.get('/v1/user/' + uid)
}

// get coda items
export const getCodaItems = (params: object) => {
  return axios.post('/v1/wallet/deposit/coda/products', params)
}

// login
export const Login = (params: ILogin) => {
  return axios.post('/v1/user/login', params)
}

// Delete
export const Unsubscribe = () => {
  return axios.post('/v1/user/apple/unsubscribe')
}

// pay
export const Pay = (payItem: IPay) => {
  return axios.post('/v1/wallet/deposit/create', payItem)
}

// blance
export const getBlance = () => {
  return axios.get('/v1/wallet/balance')
}

// get userinfo
export const getUserInfo = () => {
  return axios.get('/v1/user/ucenter')
}

// get qrcode
export const getQrCode = () => {
  return axios.get('/v1/login/qrcode')
}

// check qrcdoe
export const checkQrCode = (uuid: string) => {
  return axios.get('/v1/login/qrcode/check?uuid=' + uuid)
}

// check qrcdoe
export const logOut = () => {
  return axios.post('/v1/user/logout')
}

// more...